import "./ExcelDiffPage.css";

import React from "react";
import {DataLoadingStatus} from "shared/types/common";
import {SelectCategoryInput} from "shared/components/inputFields";
import ExcelTable from "../components/ExcelTable";
import useExcelDiff from "../hooks/useExcelDiff";

const ExcelDiffPage = () => {
    const {
        cat_num, setCat_num,
        dt1, setDt1,
        dt2, setDt2,
        dataLoadingStatus,
        checkedItems,
        handleCheckboxChange,
        filteredComparisonResult,
        isCompareDisabled,
        handleCompare,
    } = useExcelDiff();

    return (
        <div className="excel-diff-page">
            <div className="inputs-panel">
                <div className="inputs-container">
                    <SelectCategoryInput label="Category Number:" value={cat_num} valueSetter={setCat_num} lowerLimit={1} upperLimit={9999} preprocessValue={(v) => v? parseInt(v) : v} allowNegative={false} allowFraction={false}/>
                    <SelectCategoryInput label="Base Excel dt (empty for latest excel):" value={dt1} valueSetter={setDt1} placeholder='latest' lowerLimit={1} upperLimit={9999999999} preprocessValue={(val) => val} allowNegative={true} allowFraction={true}/>
                    <SelectCategoryInput label="Earlier Excel dt (empty for latest excel):" value={dt2} valueSetter={setDt2} placeholder='latest' lowerLimit={1} upperLimit={9999999999} preprocessValue={(val) => val} allowNegative={true} allowFraction={true}/>
                </div>
                <div className="checkboxes-container">
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="unmodified"
                            name="unmodified"
                            className="custom-checkbox white-checkbox"
                            checked={checkedItems.unmodified}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="unmodified" className="tooltip">
                            Show unmodified rows
                        </label>
                    </div>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="modified"
                            name="modified"
                            className="custom-checkbox blue-checkbox"
                            checked={checkedItems.modified}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="blue" className="tooltip">
                            Show modified (blue) rows
                        </label>
                    </div>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="new"
                            name="new"
                            className="custom-checkbox green-checkbox"
                            checked={checkedItems.new}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="green" className="tooltip">
                            Show new rows
                        </label>
                    </div>

                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="deleted"
                            name="deleted"
                            className="custom-checkbox red-checkbox"
                            checked={checkedItems.deleted}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="red" className="tooltip">
                            Show deleted rows
                        </label>
                    </div>
                </div>
                <div className="button-container">
                    <button className="button green-button"
                            disabled={isCompareDisabled}
                            onClick={handleCompare}>{dt1 !== dt2 ? "Compare" : "Load Excel"}
                    </button>
                </div>
            </div>
            <div className="table-container scrollable">
                {dataLoadingStatus === DataLoadingStatus.Loading ?
                    <p className="info-text">It may take up to 5 minutes. Please, be patient and don't refresh the
                        page!</p> : <></>}
                {dataLoadingStatus === DataLoadingStatus.Error ?
                    <p className="error-text">Network error occured! Please, reload the page and try
                        again...</p> : <></>}

                {filteredComparisonResult !== undefined ? <ExcelTable result={filteredComparisonResult}/> : <></>}
            </div>
        </div>
    );
}

export default ExcelDiffPage;